import { Pipe, PipeTransform } from '@angular/core';
import { normalizeString } from '../utils/string.utils';

interface LabelWithCode {
  code: string;
  label: string;
}

@Pipe({ name: 'filterLabels', standalone: true, pure: true })
export class FilterLabelsPipe implements PipeTransform {
  transform(items: LabelWithCode[], search: string | null): string[] {
    if (!search) return [];
    const normalized = normalizeString(search);
    return items
      .filter(
        (item) =>
          normalizeString(item.label).includes(normalized) ||
          normalizeString(item.code).includes(normalized),
      )
      .map((item) => item.label);
  }
}
